import { windowGA } from '../../../tools/Globals';

import { GaPageGroups } from './constants';
import * as D from './deps';

const log = D.Logger.child({ component: 'googleAnalytics/utils' });

function matchProfile(url) {
  return url.indexOf(D.Utils.Route.getProfilePath()) >= 0;
}

export function pathToPageGroup(path) {
  if (D.Utils.Route.isNowPlayingArtistRoute(path)) {
    return GaPageGroups.ARTIST_NOW_PLAYING;
  } else if (D.Utils.Route.isNowPlayingPlaylistRoute(path)) {
    return GaPageGroups.PLAYLIST_NOW_PLAYING;
  } else if (D.Utils.Route.isNowPlayingStationRoute(path)) {
    return GaPageGroups.STATION_NOW_PLAYING;
  } else if (D.Utils.Route.isNowPlayingPodcastRoute(path)) {
    return GaPageGroups.PODCAST_NOW_PLAYING;
  } else if (D.Utils.Route.isBackstageArtistPath(path)) {
    return GaPageGroups.ARTIST_BACKSTAGE;
  } else if (D.Utils.Route.isBackstageAlbumPath(path)) {
    return GaPageGroups.ALBUM_BACKSTAGE;
  } else if (D.Utils.Route.isBackstageTrackPath(path)) {
    return GaPageGroups.TRACK_BACKSTAGE;
  } else if (D.Utils.Route.isPlaylistPath(path)) {
    return GaPageGroups.PLAYLIST_BACKSTAGE;
  } else if (D.Utils.Route.isBackstageStationPath(path)) {
    return GaPageGroups.STATION_BACKSTAGE;
  } else if (D.Utils.Route.isPathInBackstagePodcast(path)) {
    return GaPageGroups.PODCAST_BACKSTAGE;
  } else if (matchProfile(path)) {
    return GaPageGroups.PROFILE;
  }
  return GaPageGroups.OTHER;
}

export function trackGaPageView(pathname) {
  trackGaView(pathToPageGroup(pathname), pathname);
}

export function trackGaView(GaPageGroup, pathname = '') {
  let pageViewArgs;

  if (GaPageGroup === GaPageGroups.OTHER) {
    pageViewArgs = pathname;
  } else {
    pageViewArgs = `/${GaPageGroup}`;
  }

  log.info(`trackGaPageView(): ping with ${JSON.stringify(pageViewArgs)}`);
  windowGA('send', 'pageview', pageViewArgs);
}
